import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { styleEntry } from '@mylighthouse/prism-ember';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';
import getChartColor from 'frontend-utils/utils/hotel-chart-color';
import GeneralDropdownsDropdownArrowButton from 'lumen/components/general/dropdowns/dropdown-arrow-button';

export interface CustomColumn extends CustomEmberTableColumn {
  clickNestedRow: (id: string) => void;
}

interface HotelStrategyTablesCellsTdHotelNestedSignature {
  Args: {
    cellData: {
      formattedValue: string;
      id: string;
      isChildRow: boolean;
      isExpandable: boolean;
      isExpanded: boolean;
      isOwnHotelInfo: boolean;
    };
    column: CustomColumn;
  };
}

export default class HotelStrategyTablesCellsTdHotelNested extends Component<HotelStrategyTablesCellsTdHotelNestedSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get bulletColor() {
    return (
      getChartColor(
        this.args.cellData.id,
        this.hotelAndMarketService.primaryAndSecondaryCompetitors,
      ) ?? ''
    );
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    {{#unless @cellData.isChildRow}}
      <div
        class="text-200--regular flex items-center justify-start"
        role="button"
        {{on "click" (fn @column.clickNestedRow @cellData.id)}}
      >
        {{#if @cellData.isExpandable}}
          <GeneralDropdownsDropdownArrowButton
            @isOpen={{@cellData.isExpanded}}
          />
        {{/if}}
        <span
          class="identifier-bullet ml-200"
          style={{styleEntry "background-color" this.bulletColor}}
        ></span>
        <span
          class="truncate
            {{if
              @cellData.isOwnHotelInfo
              'text-200--bold text-general-info-600'
            }}"
          title={{@cellData.formattedValue}}
        >{{@cellData.formattedValue}}</span>
      </div>
    {{/unless}}
  </template>
}
